import React ,{useEffect , useState} from 'react'
// import { useFetch } from '../../hooks/useFetch'
import RecipeList from '../../RecipeList'
import {projFirestore} from '../../firebase/config'

function Home() {
  const [data, setData] = useState(null)
  const [isPending, setIsPending] = useState(false)
  const [error, setError] = useState(null)


  useEffect(()=>{
    setIsPending(true)
    const unsub = projFirestore.collection('recipes').onSnapshot((snapshot)=>{
      if(snapshot.empty){
        setError('No Recipe founded')
        setIsPending(false)
      }
      else{
        console.log(snapshot.docs)
        let res=[]
        snapshot.docs.forEach(doc=>{
          res.push({id:doc.id,...doc.data()})
        })
        setData(res)
        setIsPending(false)

      }
    },(err)=>{
      setError(err.message)
      setIsPending(true)
    })
    return ()=>unsub()
  },[])
  return (
    
    <div>
      {isPending && <p className='loading'>Loading data...</p>}
      {error && <p className='error'>{error}</p>}
      {data && <RecipeList recipes={data}/>}
    </div>
  )
}

export default Home